export const MINIMUM_ACCOUNT_AGE_DAYS = 90;
export const REVIEW_US_POPUP_DELAY_MS = 5 * 60 * 1000;
